module.exports = __webpack_public_path__ + "static/media/herdy-on-shoulders-with-icecream.4acfa8f7.svg";